import {IArmor} from "../_interfaces/IArmor";

const armor:IArmor[] = [
    {
        name: "Farnrüstung",
        pr: 2,
        mr: 3,
        ini: 0,
        price: 125,
        weight: 15,
        avail: "Ungewöhnlich"
    },
    {
        name: "Gesteppte Tuchrüstung",
        pr: 2,
        mr: 0,
        ini: 0,
        price: 2,
        weight: 5,
        avail: "Durchschnittlich"
    },
    {
        name: "Espagraschuppen-Umhang",
        pr: 3,
        mr: 1,
        ini: 0,
        price: 200,
        weight: 10,
        avail: "Selten"
    },
    {
        name: "Lederrüstung",
        pr: 3,
        mr: 0,
        ini: 0,
        price: 10,
        weight: 15,
        avail: "Durchschnittlich"
    },
    {
        name: "Obsidianerhaut",
        pr: 3,
        mr: 1,
        ini: 0,
        price: 100,
        weight: 20,
        avail: "Selten"
    },
    {
        name: "Gesteppte Lederrüstung",
        pr: 4,
        mr: 0,
        ini: 0,
        price: 20,
        weight: 20,
        avail: "Durchschnittlich"
    },
    {
        name: "Kristallringrüstung",
        pr: 4,
        mr: 4,
        ini: -2,
        price: 500,
        weight: 45,
        avail: "Selten"
    },
    {
        name: "Blutkiesel",
        pr: 5,
        mr: 3,
        ini: -1,
        weight: 0,
        price: 300,
        avail: "Selten"
    },
    {
        name: "Fellrüstung",
        pr: 5,
        mr: 1,
        ini: -1,
        price: 50,
        weight: 25,
        avail: "Durchschnittlich"
    },
    {
        name: "Gehärtete Lederrüstung",
        pr: 5,
        mr: 0,
        ini: -1,
        price: 40,
        weight: 20,
        avail: "Durchschnittlich"
    },
    {
        name: "Lebendige Kristallrüstung",
        pr: 6,
        mr: 3,
        ini: -2,
        weight: 0,
        price: 1100,
        avail: "Selten"
    },
    {
        name: "Ringrüstung",
        pr: 6,
        mr: 0,
        ini: -2,
        price: 110,
        weight: 30,
        avail: "Durchschnittlich"
    },
    {
        name: "Kettenrüstung",
        pr: 7,
        mr: 0,
        ini: -3,
        price: 180,
        weight: 40,
        avail: "Durchschnittlich"
    },
    {
        name: "Kristallplattenrüstung",
        pr: 7,
        mr: 7,
        ini: -5,
        price: 12000,
        weight: 90,
        avail: "Selten"
    },
    {
        name: "Wyvernhaut",
        pr: 8,
        mr: 1,
        ini: -3,
        price: 2000,
        weight: 50,
        avail: "Selten"
    },
    {
        name: "Plattenrüstung",
        pr: 9,
        mr: 0,
        ini: -4,
        price: 3000,
        weight: 60,
        avail: "Ungewöhnlich"
    }
]
export  {armor}